import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

/** Saved-for-later wishlist (❤️ on discovery cards). Persisted to localStorage. */
const Ctx = createContext(null);
const KEY = "mapbazar_wishlist_v1";

export function WishlistProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });

  useEffect(() => {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch { /* quota */ }
  }, [items]);

  const has = useCallback((id) => items.some((x) => x.id === id), [items]);

  const toggle = useCallback((product) => {
    if (!product?.id) return;
    setItems((prev) =>
      prev.some((x) => x.id === product.id)
        ? prev.filter((x) => x.id !== product.id)
        : [...prev, {
            id: product.id, name: product.name, price: product.price,
            image: product.image, shop_id: product.shop_id, shop_name: product.shop_name,
          }]
    );
  }, []);

  const remove = useCallback((id) => setItems((p) => p.filter((x) => x.id !== id)), []);

  return (
    <Ctx.Provider value={{ items, has, toggle, remove, count: items.length }}>
      {children}
    </Ctx.Provider>
  );
}

export function useWishlist() {
  return useContext(Ctx) || { items: [], has: () => false, toggle: () => {}, remove: () => {}, count: 0 };
}
